import { render, staticRenderFns } from "./meeting.vue?vue&type=template&id=870727f8&scoped=true&"
import script from "./meeting.vue?vue&type=script&lang=js&"
export * from "./meeting.vue?vue&type=script&lang=js&"
import style0 from "./meeting.vue?vue&type=style&index=0&id=870727f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870727f8",
  null
  
)

export default component.exports